import { Button, ModalBody, Modal, ModalHeader } from "reactstrap";
import "../../components/layout/Leads/Leads.scss";
import ModalCloseIcon from "../../images/modal-close.svg";
import checkIcon from "../../images/checkGreen.png";
import ArchiveForm from "./ArchiveForm";
interface IProps {
    confirmCloseHandle: (closeTag: boolean) => void;
    confirmCloseModel: boolean;
    confirmText?: string;
    className?: string;
    headerText?: string;
    modalToggle?: () => void;
    getText?: any;
    selectedClient?:any;
}

const ArchiveModal = (props: IProps) => {
  const closeBtn = (
    <button
      className="close"
      onClick={() => props.confirmCloseHandle(false)}
      type="button"
    >
      <img src={ModalCloseIcon} alt="ModalCloseIcon" />
    </button>
  );
  return (
    <Modal
      isOpen={props.confirmCloseModel}
      className={`ToasterPopUp popup-modal contactInfoRow ${props.className}`}
      toggle={props.modalToggle}
    >
      {props.headerText && (
        <ModalHeader close={closeBtn}>
          {props.headerText}
        </ModalHeader>
      )}
      <ModalBody>
        <div className="options">
        <h4>Reason For Archive</h4>
         <ArchiveForm confirmCloseHandle={props.confirmCloseHandle}  selectedClient={props?.selectedClient}/>          
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ArchiveModal;
